// extracted by mini-css-extract-plugin
module.exports = {"stepperHeader":"register-single-vehicle-form_stepperHeader_2eJxz"};